module.exports = __webpack_public_path__ + "static/img/elasticsearch.e11babf.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/elasticsearch.png
// module id = 4W10
// module chunks = 0